/* Progressive enhancement: links and native details work without JavaScript. */
(() => {
  const menus = () => [...document.querySelectorAll('.pst-shop,.pst-mobile-menu')];
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const inside = event.target.closest('.pst-shop,.pst-mobile-menu');
    menus().forEach(menu => {
      if (menu !== inside || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = menus().find(menu => menu.open && menu.contains(document.activeElement));
    menus().forEach(menu => { menu.open = false; });
    open?.querySelector('summary')?.focus();
  });
})();

/* Reuse Horizon's completed native cart event; never make a cart request here. */
import('@shopify/events').then(({ StandardEvents }) => {
  let revision = 0;
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    const currentRevision = ++revision;
    if (!event.promise || typeof event.promise.then !== 'function') return;
    event.promise.then(({ cart, detail } = {}) => {
      if (currentRevision !== revision) return;
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (!Number.isSafeInteger(count) || count < 0) return;
      document.querySelectorAll('[data-pst-cart-count]').forEach(node => {
        node.textContent = String(count);
      });
      document.querySelectorAll('[data-pst-cart-link]').forEach(link => {
        link.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
      });
    }).catch(() => {
      // The native cart owns error messages. Keep the last confirmed count.
    });
  });
}).catch(() => {
  // Server-rendered cart links remain available if the native module fails.
});
